import React from "react";
import Header from "../components/Header";
import { LeadershipBanner, MembersInfo } from "../components/LeadershipComp";
import Footer from "../components/Footer";

const Leadership = () => {
  return (
    <>
    <title>Leadership</title>
      <Header />
      <LeadershipBanner />
      <MembersInfo />
      <Footer />
    </>
  );
};

export default Leadership;
